import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState, useRef } from 'react';
import { Grid, CnTag, CnStatusTag, CnBalloon, CnRadioGroup, CnRadio, CnMessage, } from '@alife/cn-ui';
import $i18n from 'panda-i18n';
import { store } from '@ice/stark-data';
import { feedbackHandler, reportHottag } from '$src/utils';
import { defaultFeedbackApi, hottagPrefix } from 'src/const';
const { Row } = Grid;
/**
 * 筛选条件标签
 * @param props
 * @returns
 */
function FilterTags(props) {
    const conditionViewSlot = store.get('cn-one-search-condition-view-right-slot');
    const ConditionViewSlotView = conditionViewSlot?.component;
    const [feedbackValue, setFeedbackValue] = useState();
    const { finalTranslateTags, searchTags, baseContext, disabled } = props;
    const searchTagRef = useRef(null);
    useEffect(() => {
        if (finalTranslateTags?.length > 0) {
            setFeedbackValue(null);
            searchTagRef.current = searchTags;
        }
    }, [finalTranslateTags]);
    const onChangeFeedback = async (value) => {
        setFeedbackValue(value);
        // TODO: 上报反馈数据
        const finalTokenList = (searchTagRef.current || []).map((item) => {
            const { name, values, labels } = item;
            const rStr = [];
            const tmpValues = Array.isArray(labels) && labels.length > 0 ? labels : values;
            if (name) {
                rStr.push(name);
            }
            if (tmpValues.length) {
                rStr.push(tmpValues.join(','));
            }
            return rStr.join(':');
        });
        const algorithmOutput = (finalTranslateTags || []).map((item) => `${item.label}:${item.value}`);
        const res = await feedbackHandler(defaultFeedbackApi, baseContext.bizAccessKey, baseContext.operatorId, finalTokenList.join('|'), algorithmOutput.join('|'), value);
        if (res) {
            CnMessage.success($i18n.get({ id: 'FeedbackSuccess', dm: '反馈成功' }));
            reportHottag({
                hottag: `${hottagPrefix}.searchTag.feedbackSuccess`,
                name: '搜索结果-反馈',
                c10: JSON.stringify({
                    finalTokenList,
                    algorithmOutput,
                    value,
                    operatorId: baseContext.operatorId,
                    bizAccessKey: baseContext.bizAccessKey,
                }),
            });
        }
    };
    const errorData = [
        {
            id: 'condition_error',
            value: 'conditionError',
            label: $i18n.get({
                id: 'QueryConditionIsNotCorrect',
                dm: '查询条件不对',
            }),
        },
        {
            id: 'query_data_error',
            value: 'queryDataError',
            label: $i18n.get({
                id: 'QueryDataResultsAreNotCorrect_2035676713',
                dm: '查询数据结果不对',
            }),
        },
        {
            id: 'other',
            value: 'otherError',
            label: $i18n.get({ id: '31255237310418944.CNTM', dm: '其他' }),
        },
    ];
    return (_jsxs(Row, { className: 'translate-tags-container', children: [baseContext.bizAccessKey && baseContext.operatorId ? (_jsx("div", { className: 'translate-tags-btn', children: disabled ? (_jsx(CnTag, { type: 'normal', size: 'small', children: $i18n.get({
                        id: 'feedbackBtnText',
                        dm: '我要反馈',
                    }) })) : (_jsx(CnBalloon, { v2: true, arrowPointToCenter: true, popupStyle: { maxWidth: 400 }, align: 'br', closable: false, triggerType: 'hover', className: 'on-search-feedback-balloon', trigger: _jsx(CnTag, { type: 'primary', size: 'small', color: feedbackValue ? '#284cc0' : '', children: $i18n.get({
                            id: 'feedbackBtnText',
                            dm: '我要反馈',
                        }) }), children: _jsx(CnRadioGroup, { value: feedbackValue, onChange: onChangeFeedback, children: errorData.map((item) => {
                            return (_jsx(CnRadio, { id: item.id, value: item.value, className: 'error-item', children: item.label }, item.id));
                        }) }) })) })) : null, _jsxs("div", { className: 'translate-tags-label', children: [_jsx("img", { src: 'https://img.alicdn.com/imgextra/i1/O1CN013KJ3zv1HoHGOQBeAb_!!6000000000804-2-tps-44-25.png' }), _jsx("span", { children: $i18n.get({
                            id: 'tagContainerLabel',
                            dm: '条件为：',
                        }) })] }), finalTranslateTags.map((tag) => {
                return (_jsxs(CnStatusTag, { status: 'info', className: 'translate-tag', children: [tag.label, ": ", _jsx("span", { title: tag.value, children: tag.value })] }, `${tag.label}-${tag.value}`));
            }), ConditionViewSlotView ? (_jsx("div", { className: 'cn-one-search-condition-slot', children: _jsx(ConditionViewSlotView, { getFilterContent: props.getNewViewDetail }) })) : null] }));
}
FilterTags.displayName = 'OneSearch.FilterTags';
export default FilterTags;
